export const getLabel = (
  t: (key: string) => string,
  key: string,
  formType?: "Default" | "Simplified"
): string => {
  if (formType === "Simplified") {
    const simplifiedKey = `${key}Simplified`;
    const translation = t(simplifiedKey);
    if (translation !== simplifiedKey) return translation;
  }
  return t(key);
};